/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  HoundraceMysteryBoxes,
  HoundraceMysteryBoxesInterface,
  LootboxesConstructor,
} from "../HoundraceMysteryBoxes";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            internalType: "bool",
            name: "canBeOpened",
            type: "bool",
          },
        ],
        internalType: "struct LootboxesConstructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
    ],
    name: "LootboxOpen",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        components: [
          {
            internalType: "address[]",
            name: "rewardContracts",
            type: "address[]",
          },
          {
            internalType: "uint256[]",
            name: "tokenIds",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "amounts",
            type: "uint256[]",
          },
          {
            internalType: "enum Payment.PaymentTypes[]",
            name: "rewardTypes",
            type: "uint8[]",
          },
        ],
        indexed: false,
        internalType: "struct Box.Struct[]",
        name: "loot",
        type: "tuple[]",
      },
    ],
    name: "LootboxOpened",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "NewLootboxes",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "bool",
        name: "canBeOpened",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "_operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "isOperator",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "token_uri",
        type: "string",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "boxId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
    ],
    name: "open",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "boxId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        components: [
          {
            internalType: "address[]",
            name: "rewardContracts",
            type: "address[]",
          },
          {
            internalType: "uint256[]",
            name: "tokenIds",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "amounts",
            type: "uint256[]",
          },
          {
            internalType: "enum Payment.PaymentTypes[]",
            name: "rewardTypes",
            type: "uint8[]",
          },
        ],
        internalType: "struct Box.Struct[]",
        name: "loot",
        type: "tuple[]",
      },
    ],
    name: "opened",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            internalType: "bool",
            name: "canBeOpened",
            type: "bool",
          },
        ],
        internalType: "struct LootboxesConstructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "setOpenStatus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "whitelists",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type HoundraceMysteryBoxesConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HoundraceMysteryBoxesConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HoundraceMysteryBoxes__factory extends ContractFactory {
  constructor(...args: HoundraceMysteryBoxesConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "HoundraceMysteryBoxes";
  }

  deploy(
    input: LootboxesConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<HoundraceMysteryBoxes> {
    return super.deploy(
      input,
      overrides || {}
    ) as Promise<HoundraceMysteryBoxes>;
  }
  getDeployTransaction(
    input: LootboxesConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): HoundraceMysteryBoxes {
    return super.attach(address) as HoundraceMysteryBoxes;
  }
  connect(signer: Signer): HoundraceMysteryBoxes__factory {
    return super.connect(signer) as HoundraceMysteryBoxes__factory;
  }
  static readonly contractName: "HoundraceMysteryBoxes";
  public readonly contractName: "HoundraceMysteryBoxes";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HoundraceMysteryBoxesInterface {
    return new utils.Interface(_abi) as HoundraceMysteryBoxesInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HoundraceMysteryBoxes {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as HoundraceMysteryBoxes;
  }
}
